export default __webpack_public_path__ + "static/media/Aura-Egg__67.7d79535d.png";